import { useBuilderStore } from '../../store/builderStore';
import { DesignInfo } from "../DesignInfo";
import { ColorVariants } from "../ColorVariants";
import { SizeVariants } from "../SizeVariants";
import { formatPrice } from "@printtat/shared";

export const ProductPanel = () => {
  const productConfig = useBuilderStore((s) => s.productConfig);
  const basePrice = useBuilderStore((s) => s.basePrice);

  return (
    <div className="flex flex-col">
      <DesignInfo />
      <div className="h-px bg-gray-100 mx-2.5" />
      <div className="flex flex-col px-2.5 py-2 pb-1.5">
        <span className="text-[13px] font-semibold text-[#1a1a1a] leading-snug capitalize">
          {productConfig.type}
        </span>
        <span className="text-[11px] text-[#888] mt-0.5">
          {formatPrice(basePrice)} / unit
        </span>
      </div>
      <div className="h-px bg-gray-100 mx-2.5" />
      <ColorVariants />
      <div className="h-px bg-gray-100 mx-2.5" />
      <SizeVariants />
    </div>
  );
};
